// @ts-nocheck
import { EnvService } from "@/services/Environment/Environment";

export async function initPylon(
  name?: string,
  email?: string,
  avatar_url?: string,
  tenant_id?: string,
  isFreeUser?: boolean
  //email_hash?: string
) {
  if (!name || !email || !EnvService.getVar("PYLON_ID") || isFreeUser) {
    return;
  }

  let email_hash;
  try {
    const res = await fetch("/api/pylon", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ identifier: email }),
    });
    if (!res.ok) {
      throw new Error(`HTTP ${res.status}`);
    }
    const data = await res.json();
    email_hash = data?.hash;
  } catch (err) {
    console.error("Failed to get Pylon email hash from backend:", err);
  }

  const settings = avatar_url
    ? {
        app_id: EnvService.getVar("PYLON_ID"),
        email,
        name,
        avatar_url,
        account_external_id: tenant_id,
        email_hash,
      }
    : {
        app_id: EnvService.getVar("PYLON_ID"),
        email,
        name,
        account_external_id: tenant_id,
        email_hash,
      };

  window.pylon = {
    chat_settings: settings,
  };
}

export function openPylonChat() {
  if (typeof window !== "undefined" && window.Pylon) {
    window.Pylon("show");
  }
}

export function triggerPylonMessage(message?: string) {
  if (typeof window !== "undefined" && window.Pylon) {
    window.Pylon("showNewMessage", message);
  }
}

const bubble = { chatOpen: false, unreadCount: 0, suppressed: false };

/* Needs "default hide chat bubble" and "show chat bubble if unreads" off in the
   Pylon dashboard: with either on, Pylon rejects showChatBubble and hideChatBubble */
function syncPylonBubble() {
  if (typeof window === "undefined" || !window.Pylon) return;
  const visible =
    !bubble.suppressed && (bubble.chatOpen || bubble.unreadCount > 0);
  window.Pylon(visible ? "showChatBubble" : "hideChatBubble");
}

/* Tool pages and the chat page never show the bubble, not even for unread replies */
export function setPylonBubbleSuppressed(suppressed: boolean) {
  bubble.suppressed = suppressed;
  syncPylonBubble();
}

/* The bubble's button lives in a srcdoc iframe, so the page stylesheet cannot reach it.
   Its rem is the iframe's own, so sizes are in vw (the frame's width) to scale with the page. */
const BUBBLE_FRAME_CSS = `
.PylonChat-bubbleContainer {
  --base-scale: 1 !important;
  --size: 80vw !important;
  position: absolute !important;
  left: 0;
  bottom: 0;
  border-radius: 15vw !important;
}
.PylonChat-bubbleContainer > div:first-child {
  height: calc(var(--size) - 25vw) !important;
}
.PylonChat-bubbleUnreadIssues {
  top: 0 !important;
  right: 10vw !important;
  min-width: 15vw !important;
  height: 40vw !important;
  padding: 0 12.5vw !important;
  font-size: 27.5vw !important;
  box-shadow: none !important;
}
`;

function styleBubbleFrame(frame: HTMLIFrameElement) {
  const doc = frame.contentDocument;
  if (!doc?.head || doc.getElementById("noxus-pylon-bubble")) return;
  const style = doc.createElement("style");
  style.id = "noxus-pylon-bubble";
  style.textContent = BUBBLE_FRAME_CSS;
  doc.head.appendChild(style);
}

/* Pylon mounts the bubble frame once and only toggles its container's class,
   so the observer stops as soon as the frame exists */
function watchBubbleFrame() {
  const attach = () => {
    const frame = document.querySelector<HTMLIFrameElement>(
      ".PylonChat-bubbleFrameContainer iframe"
    );
    if (!frame) return false;
    styleBubbleFrame(frame);
    frame.addEventListener("load", () => styleBubbleFrame(frame));
    return true;
  };
  if (attach()) return;
  const observer = new MutationObserver(() => {
    if (attach()) observer.disconnect();
  });
  observer.observe(document.body, { childList: true, subtree: true });
}

export function setupPylonEditorHideEvent() {
  if (typeof window !== "undefined") {
    let attempts = 0;

    const intervalId = setInterval(() => {
      attempts++;

      if (window.Pylon && attempts <= 50) {
        window.Pylon("onShow", function () {
          bubble.chatOpen = true;
          syncPylonBubble();
        });
        window.Pylon("onHide", function () {
          bubble.chatOpen = false;
          syncPylonBubble();
        });
        window.Pylon("onChangeUnreadMessagesCount", function (count) {
          bubble.unreadCount = count;
          syncPylonBubble();
        });
        syncPylonBubble();
        watchBubbleFrame();
        clearInterval(intervalId);
      } else if (attempts > 50) {
        clearInterval(intervalId);
      }
    }, 500);
  }
}
